import {
  EnumTagSemanticoDTOElementoRicerca,
  EnumTagSemanticoDTOTipo,
  TagSemanticoDTO,
} from '@framework/api-client';
import { t } from '@framework/i18n';
import {
  SearchableField,
  SearchableFieldGroup,
  SearchableFieldType,
  isPlainSearchableField,
  isRangeSearchableFieldType,
} from '@framework/ui';

function mapType(tag: TagSemanticoDTO | undefined): SearchableFieldType | null {
  const tagType = tag?.tipo;

  if (!tagType) return null;

  if (
    tag.elementoRicerca ===
    EnumTagSemanticoDTOElementoRicerca.RICERCA_CON_MENU_TENDINA
  ) {
    return SearchableFieldType.Select;
  }

  switch (tagType) {
    case EnumTagSemanticoDTOTipo.NUMERIC:
      if (
        tag.elementoRicerca ===
        EnumTagSemanticoDTOElementoRicerca.RICERCA_PER_INTERVALLO
      ) {
        return SearchableFieldType.NumberRange;
      }
      return SearchableFieldType.Number;

    case EnumTagSemanticoDTOTipo.TEXT:
      return SearchableFieldType.Text;

    case EnumTagSemanticoDTOTipo.DATE:
      if (
        tag.elementoRicerca ===
        EnumTagSemanticoDTOElementoRicerca.RICERCA_PER_INTERVALLO
      ) {
        return SearchableFieldType.DateRange;
      }
      return SearchableFieldType.Date;

    case EnumTagSemanticoDTOTipo.BOOLEAN:
      return SearchableFieldType.Switch;

    case EnumTagSemanticoDTOTipo.GEOMETRY:
    default:
      return SearchableFieldType.Text;
  }
}

export const searchableFieldFromName = (name: string | undefined | null) =>
  `${name}_dal`;
export const searchableFieldToName = (name: string | undefined | null) =>
  `${name}_al`;

export function semanticTagToSearchableField(
  tag: TagSemanticoDTO,
): SearchableField | null {
  const fieldType = mapType(tag);

  if (!fieldType) {
    return null;
  }

  if (isPlainSearchableField(fieldType)) {
    return {
      type: fieldType,
      label: tag.titolo ?? tag.nome ?? '',
      name: tag.nome ?? '',
      group: SearchableFieldGroup.SemanticTags,
    };
  }

  if (isRangeSearchableFieldType(fieldType)) {
    return {
      type: fieldType,
      label: tag.titolo ?? tag.nome ?? '',
      name: tag.nome ?? '',
      group: SearchableFieldGroup.SemanticTags,
      from: {
        name: searchableFieldFromName(tag.nome),
        label: t('semantic-tag-searchable-field.from', `Da`),
      },
      to: {
        name: searchableFieldToName(tag.nome),
        label: t('semantic-tag-searchable-field.to', `A`),
      },
    };
  }

  if (fieldType === SearchableFieldType.Select) {
    return {
      type: fieldType,
      label: tag.titolo ?? tag.nome ?? '',
      name: tag.nome ?? '',
      group: SearchableFieldGroup.SemanticTags,
      options:
        tag.opzioniRicerca?.map(v => ({
          value: v.valore ?? '',
          label: v.etichetta ?? '',
        })) ?? [],
    };
  }

  return null;
}

export function mapSemanticTagsToSearchableFields(
  tags: TagSemanticoDTO[] | null | undefined,
) {
  if (!tags) return [];
  return (
    tags
      // I tag semantici di tipo GEOMETRY non sono gestiti
      .filter(tag => tag.tipo !== EnumTagSemanticoDTOTipo.GEOMETRY)
      .map(semanticTagToSearchableField)
      .filter(Boolean) as SearchableField[]
  );
}
